import styles from './index.module.scss';
import { Flex } from '@phi/components/layout';
import { utility } from '@phi/components';
import { do_nothing, random_id } from '@phi/util';
import { Unary } from '@vaaas/fpts/data';
import { defineComponent, h } from 'vue';
import { isEnterOrSpace } from '@frontend/keyboard';

const svg = ({ id, onClick, checked }: {
    id: string;
    onClick: Unary<MouseEvent, void>;
    checked: boolean;
}) =>  h('svg', {
    id,
    class: {
        [styles.svg]: true,
        [styles.active]: checked,
    },
    width: 24,
    height: 24,
    version: '1.1',
    viewBox: '0 0 6.35 6.325',
    onClick: onClick,
}, [
    h('rect', {
        transform: 'scale(-1)',
        x: '-6.22',
        y: '-6.22',
        width: '6.09',
        height: '6.09',
        rx: '.529',
        ry: '.529',
        fill: 'none',
    }),
    h('path', {
        class: { [utility.hidden]: !checked },
        d: 'm1.21 3.52 1.45 1.18 2.27-2.84',
        fill: 'none',
    }),
]);

export const FormCheckbox = defineComponent({
    props: {
        value: {
            required: true,
            type: Boolean,
        },
    },

    emits: {
        'update:value': (x: boolean) => true,
    },

    setup(props, { emit }) {
        function toggle() {
            emit('update:value', !props.value);
        }

        return () => svg({ onClick: toggle, checked: props.value, id: '' });
    },
});

export const FormCheckboxWithLabel = defineComponent({
    props: {
        value: {
            required: true,
            type: Boolean,
        },
    },

    emits: {
        'update:value': (x: boolean) => true,
    },

    setup(props, { emit, slots }) {
        function toggle() {
            emit('update:value', !props.value);

        }

        function on_key_down(e: KeyboardEvent) {
            if (isEnterOrSpace(e))
                toggle();
        }

        const id = random_id();

        return () => h(Flex, {
            direction: 'row',
            tabIndex: '0',
            onKeydown: on_key_down,
            align: 'center',
            class: [
                styles.checkbox_with_label,
                utility.pointer,
            ],
            onClick: toggle,
        }, () => [
            svg({
                id,
                onClick: do_nothing,
                checked: props.value,
            }),
            h('label', {
                for: id,
                class: [
                    utility.m_none,
                    utility.pointer,
                ],
            }, slots.default ? slots.default() : ''),
        ]);
    }
});
